import _ from "lodash";

export const entity = {
    name: 'Unit',
    facets: [{name: 'codeName', uniqueName: true}],
    fields:[
        {type: 'SectorOfActivity', nullable: true}, 'Scope',
        {path: 'revenue', type: 'integer', nullable: true},
        {path: 'status', type: 'Status'}
    ],
    filters: [
        {
            name: 'byStatus',
            path: "status",
            object: "Status",
            display: 'name',
            isDefault: false,
            client: true,
            query: function(context) {
                const status = _.get(context, 'data.status.id');
                return status ? {status: status} : {};
            }
        }
    ]
}

export const module_ = {
    object: 'Unit',
    name: 'Group',
    category: {
        path: 'referential',
        icon: 'server'
    },
    defaultSortBy: 'code',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: ['code', 'name', {path: 'sectorOfActivity'},
            {path: 'scope'},
            {path: 'revenue', tKey: 'revK€'}],
        form: [
            {path: 'code', placeholder: 'renseigner un code unique', noSpaces: true},
            {path: 'name', placeholder: 'renseigner un nom unique'},
            {path: 'sectorOfActivity', display: 'fullName', placeholder : 'Sélectionner le secteur d’activité du groupe'},
            {path: 'scope', placeholder : 'Sélectionner la couverture géographique du groupe'},
            {path: 'revenue', minValue: 0, tKey: 'revK€'},
            {path: 'status', type: 'toggle', default: {id: 'actif'}}
        ]
    },
    filters: ['byStatus']
}
